// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".push-notification-form {\n  margin: 10px;\n}\n.smile-icon {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.push-text-area {\n  height: 80px !important;\n}\n", ""]);
// Exports
module.exports = exports;
